import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SimInfoResource } from '@dch/products-business-logic';
import { EnvironmentService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-e-sim-qr-code',
  templateUrl: './e-sim-qr-code.component.html',
})
export class ESimQrCodeComponent implements OnInit {
  @Input()
  eSimData: SimInfoResource;

  @Output()
  eSimPanelExpandedEventEmitter = new EventEmitter<void>();

  qrCodeValue: string;
  isMobile: boolean;

  constructor(private environmentService: EnvironmentService) {}

  ngOnInit(): void {
    this.isMobile = this.environmentService.isMobile;
  }

  showQrCodeSection() {
    this.qrCodeValue = this.eSimData.activationCode;
    this.eSimPanelExpandedEventEmitter.next();
  }
}
